module.exports = __webpack_public_path__ + "static/fonts/iconfont.53691d6.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/iconfont.woff?t=1555750596622
// module id = caQa
// module chunks = 38